import { Point } from "@/features/types";

export class UnitUtils {
  static fromMicro(val: number, decimals: null | number = null) {
    return this.round(val / 1000000, decimals);
  }

  static latLngFromMicro(point: Point): google.maps.LatLngLiteral {
    return {
      lat: this.fromMicro(point.latitudeMicro),
      lng: this.fromMicro(point.longitudeMicro),
    };
  }

  static coordinatesFromMicro(point: Point): [number, number] {
    return [
      this.fromMicro(point.longitudeMicro),
      this.fromMicro(point.latitudeMicro),
    ];
  }

  static fromMilli(val: number, decimals: null | number = null) {
    return this.round(val / 1000, decimals);
  }

  static fromCms(val: number, decimals: null | number = null) {
    return this.round(val / 100, decimals);
  }

  static round(num: number, decimals: number | null = null) {
    if (decimals === null) return num;

    const base = Math.pow(10, decimals);
    return Math.round(num * base) / base;
  }
}
